import axios from '@axios'

const PREFIX = '/gclick'

export default {
  getDepartamentos(page, pageSize, sort) {
    return axios.post(`${PREFIX}/departamentos`, { page, pageSize, sort })
  },
  getFluxos(page, pageSize, sort) {
    return axios.post(`${PREFIX}/fluxos`, { page, pageSize, sort })
  },
  getProcessos(departamentoId, page, pageSize, sort) {
    return axios.post(`${PREFIX}/processos`, {
      departamentoId,
      page,
      pageSize,
      sort,
    })
  },
}
